module.exports = __webpack_public_path__ + "static/media/SBPhotography_1-1440w.a0e1ae5c.jpg";